import { render, staticRenderFns } from "./WorkReadCollection.vue?vue&type=template&id=1b5cee9b&"
import script from "./WorkReadCollection.vue?vue&type=script&lang=ts&"
export * from "./WorkReadCollection.vue?vue&type=script&lang=ts&"
import style0 from "./WorkReadCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VDataTable,VIcon,VRow,VTextField})
